import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot  } from '@angular/router';
import { StoreService } from '../../shared/services';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private storeService: StoreService) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (this.legitUser(currentUser)) {
              return true;
            }
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
    private legitUser(user): boolean {
      if (user.hasOwnProperty('_id') && user.hasOwnProperty('token')) {
        return true;
      } else {
        return false;
      }
    }
}
